(function () {
  var DEFERRED_SELECTOR = "[data-locale-src], [data-locale-srcset]";

  function hydrateElement(element) {
    var srcset = element.getAttribute("data-locale-srcset");
    var src = element.getAttribute("data-locale-src");

    if (srcset) {
      element.setAttribute("srcset", srcset);
      element.removeAttribute("data-locale-srcset");
    }
    if (src) {
      element.setAttribute("src", src);
      element.removeAttribute("data-locale-src");
    }
  }

  function hydrateGroup(element) {
    var picture = element.closest ? element.closest("picture") : null;
    var scope = picture || element;
    var deferred = scope.querySelectorAll
      ? scope.querySelectorAll(DEFERRED_SELECTOR)
      : [];

    hydrateElement(element);
    for (var i = 0; i < deferred.length; i++) {
      hydrateElement(deferred[i]);
    }
  }

  function hydrateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var deferred = scope.querySelectorAll(DEFERRED_SELECTOR);
    for (var i = 0; i < deferred.length; i++) {
      hydrateGroup(deferred[i]);
    }
  }

  var visibilityObserver = null;
  if ("IntersectionObserver" in window) {
    visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          visibilityObserver.unobserve(entry.target);
          hydrateGroup(entry.target);
        });
      },
      { rootMargin: "200px" }
    );
  }

  function observeTarget(element) {
    if (element.tagName !== "SOURCE") return element;
    return element.closest ? element.closest("picture") || element : element;
  }

  function watch(root) {
    if (!visibilityObserver) {
      hydrateAll(root);
      return;
    }
    var scope = root && root.querySelectorAll ? root : document;
    var deferred = scope.querySelectorAll(DEFERRED_SELECTOR);
    for (var i = 0; i < deferred.length; i++) {
      visibilityObserver.observe(observeTarget(deferred[i]));
    }
  }

  window.hydrateLocaleImages = hydrateAll;
  window.watchLocaleImages = watch;

  document.addEventListener("language:change", function () {
    hydrateAll(document);
  });

  function start() {
    watch(document);

    if (!("MutationObserver" in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(DEFERRED_SELECTOR)) {
            if (visibilityObserver) {
              visibilityObserver.observe(observeTarget(node));
            } else {
              hydrateGroup(node);
            }
          }
          watch(node);
        }
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
